export default __webpack_public_path__ + "static/media/3.6555b5b3.png";